import React, { useState, useEffect } from "react";
import { getData } from "../API";
import Piechart from "./Piechart";
import { PieChart } from "react-minimal-pie-chart";
import LineChart from "./LineChart";
import CountUp from "react-countup";
import AOS from "aos";
import "aos/dist/aos.css";

function Dashboard() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  const [dashboardData, setDashboardData] = useState({});
  const [establishmentData, setEstablishmentData] = useState({});

  const fetchData = async () => {
    try {
      const res = await getData("SurveyDetails/Dashboard");
      console.log(res.data);
      // const res = await res.json();
      setDashboardData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchEstablishmentData = async () => {
    try {
      const res = await getData("SurveyDetails/DashboardEstablishmentCounts");
      console.log(res.data);
      // const res = await res.json();
      setEstablishmentData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchEstablishmentData();
  }, []);
  // const fetchData = async () => {
  //     try {
  //         const res = await getData('SurveyDetails/Dashboard');

  //         if (!res.ok) {
  //             throw new Error(`HTTP error! status: ${res.status}`);
  //         }

  //         const res = await res.json();
  //         setDashboardData(res.data);
  //     } catch (error) {
  //         console.error('Error fetching data:', error);
  //     }
  // };

  // Ensure this useEffect runs after login and fetches the data

  const pieChartData = [
    {
      name: "Resident Individual",
      value: dashboardData.residentIndividual,
      color: "#FF8E9E",
    },
    {
      name: "Resident Apartment",
      value: dashboardData.residentApartment,
      color: "#E0144C",
    },
    {
      name: "Commercial Individual",
      value: dashboardData.commercialIndividual,
      color: "#FF6347",
    },
    {
      name: "Commercial Apartment",
      value: dashboardData.commercialApartment,
      color: "#FF4500",
    },
  ];

  return (
    <main className="page-content content">
      <div className="container-fluid p-0">
        <div className="row align-items-center mb-3">
          <div className="col-md-12">
            <h1 className="title_pages">Dashboard</h1>
          </div>
        </div>

        <div className="row align-items-center mb-3">
          {/* {[
            {
              title: "Grand Total",
              value: dashboardData.grandTotal,
              imgSrc: "../img/dashboard1.svg",
            },
            {
              title: "Today Total",
              value: dashboardData.todayTotal,
              imgSrc: "../img/dashboard2.svg",
            },
            {
              title: "Resident Individual",
              value: dashboardData.residentIndividual,
              imgSrc: "../img/dashboard3.svg",
            },
            {
              title: "Resident Apartment",
              value: dashboardData.residentApartment,
              imgSrc: "../img/dashboard4.svg",
            },
            {
              title: "Commercial Individual",
              value: dashboardData.commercialIndividual,
              imgSrc: "../img/dashboard5.svg",
            },
            {
              title: "Commercial Apartment",
              value: dashboardData.commercialApartment,
              imgSrc: "../img/dashboard6.svg",
            },
          ].map((card, index) => (
            <div className="col-md-4" key={index}>
              <div
                data-aos="fade-up"
                className="card mb-3"
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                <div className="card-body custom-shadow">
                  <div className="row align-items-center">
                    <div className="col-md-9 col-10">
                      <div className="card_text">
                        <h1 className="title_pages">
                          <CountUp end={card.value} />
                        </h1>
                        <p>{card.title}</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-2">
                      <div className="card_img">
                        <img
                          src={card.imgSrc}
                          className="img-fluid"
                          alt="dashboard"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))} */}
          <div className="col-md-3">
            <div className="row">
              <div className="col-12">
                <div
                  data-aos="fade-up"
                  className="card mb-3"
                  style={{
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                >
                  <div className="custom-shadow card-color">
                    <div className="card-text text-center new-card">
                      <p>
                        <span>TOTAL RECORDS</span>
                      </p>
                      <p>{establishmentData?.totalCount ?? 0}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div>
                  {establishmentData.zoneWiseStats?.map((zone, index) => (
                    <div
                      key={index}
                      data-aos="fade-up"
                      className="card mb-3"
                      style={{
                        boxShadow:
                          "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                      }}
                    >
                      <div className="custom-shadow zone-card">
                        <div className="card-text text-center new-card">
                          <p>
                            <span>
                              {zone.zoneName?.toUpperCase() || "UNKNOWN"}{" "}
                              RECORDS
                            </span>
                          </p>
                          <p>{zone.zoneCount}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="row">
              <div className="col-12">
                <div
                  data-aos="fade-up"
                  className="card mb-3"
                  style={{
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                >
                  <div className="custom-shadow green-card">
                    <div className="card-text text-center new-card">
                      <p>
                        <span>VERIFIED</span>
                      </p>
                      <p>{establishmentData.verifiedCount ?? 0}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div>
                  {establishmentData.zoneWiseStats?.map((zone, index) => (
                    <div
                      key={index}
                      data-aos="fade-up"
                      className="card mb-3"
                      style={{
                        boxShadow:
                          "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                      }}
                    >
                      <div className="custom-shadow verified-card">
                        <div className="card-text text-center new-card">
                          <div className="row">
                            <div className="col-md-6">
                              <p>RESIDENTIAL</p>
                              <p>{zone.verified?.residential ?? 0}</p>
                            </div>
                            <div className="col-md-6">
                              <p>COMMERCIAL</p>
                              <p>{zone.verified?.commercial ?? 0}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">  
            <div className="row">
              <div className="col-12">
                <div
                  data-aos="fade-up"
                  className="card mb-3"
                  style={{
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                >
                  <div className="custom-shadow red-card">
                    <div className="card-text text-center new-card">
                      <p>
                        <span>UNVERIFIED</span>
                      </p>
                      <p>{establishmentData.unverifiedCount ?? 0}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div>
                  {establishmentData.zoneWiseStats?.map((zone, index) => (
                    <div
                      key={index}
                      data-aos="fade-up"
                      className="card mb-3"
                      style={{
                        boxShadow:
                          "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                      }}
                    >
                      <div className="custom-shadow verified-card">
                        <div className="card-text text-center new-card">
                          <div className="row">
                            <div className="col-md-6">
                              <p>RESIDENTIAL</p>
                              <p>{zone.unverified?.residential ?? 0}</p>
                            </div>
                            <div className="col-md-6">
                              <p>COMMERCIAL</p>
                              <p>{zone.unverified?.commercial ?? 0}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="row">
              <div className="col-12">
                <div
                  data-aos="fade-up"
                  className="card mb-3"
                  style={{
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                >
                  <div className="custom-shadow waiting-card">
                    <div className="card-text text-center new-card">
                      <p>
                        <span>WAITING FOR APPROVAL</span>
                      </p>
                      <p>{establishmentData.waitingForApprovalCount ?? 0}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div>
                  {establishmentData.zoneWiseStats?.map((zone, index) => (
                    <div
                      key={index}
                      data-aos="fade-up"
                      className="card mb-3"
                      style={{
                        boxShadow:
                          "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                      }}
                    >
                      <div className="custom-shadow waiting-inner-card">
                        <div className="card-text text-center new-card">
                          <div className="row">
                            <div className="col-md-6">
                              <p>RESIDENTIAL</p>
                              <p>{zone.waitingForApproval?.residential ?? 0}</p>
                            </div>
                            <div className="col-md-6">
                              <p>COMMERCIAL</p>
                              <p>{zone.waitingForApproval?.commercial ?? 0}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="row">
              <div className="col-12">
                <div
                  data-aos="fade-up"
                  className="card mb-3"
                  style={{
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                >
                  <div className="custom-shadow today-total">
                    <div className="card-text text-center new-card">
                      <p>
                        <span>Today Total</span>
                      </p>
                      <p>{establishmentData.todayTotal ?? 0}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="custom-shadow today-total-inner">
                  <div className="card-text text-center new-card">
                    <div className="row">
                      <div className="col-md-6">
                        <p>RESIDENTIAL</p>
                        <p>{establishmentData.todayResidential ?? 0}</p>
                      </div>
                      <div className="col-md-6">
                        <p>COMMERCIAL</p>
                        <p>{establishmentData.todayCommercial ?? 0}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div data-aos="fade-up" className="col-md-12">
            <Piechart data={pieChartData} />
            {/* <LineChart data={pieChartData}/> */}
          </div>
        </div>
      </div>
    </main>
  );
}

export default Dashboard;
